// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"24f6af69","118":"f0c43b14","327":"1820fdc7","358":"9d887fdf","431":"bd81a619","473":"9fc7f93a","518":"38277557","761":"b19d1a9d","765":"9da40b66","779":"c7db16da"}[chunkId] + ".js";
};